"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.string.starts-with");
var _acceesoryCargo = _interopRequireDefault(require("./acceesoryCargo.vue"));
var _vuex = require("vuex");
var _lightInput = _interopRequireDefault(require("@/components/lightEditor/lightInput.vue"));
var _MsgCheckTextDialog = _interopRequireDefault(require("@/views/booking/bookingSpace/components/MsgCheckTextDialog.vue"));
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  components: {
    MsgCheckTextDialog: _MsgCheckTextDialog.default,
    LightInput: _lightInput.default,
    acceesoryCargo: _acceesoryCargo.default
  },
  props: {
    formInfo: {
      type: Object
    },
    cargoList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    bookingTypeList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    transportationTermsList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    paidTypeList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    rules: {
      type: Object
    },
    packageTypeList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    bkCargoDiff: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    differentKeys: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    titleFlag: {
      type: String,
      default: ''
    },
    isShow: {
      type: Boolean,
      default: true
    },
    isShowUnload: {
      type: Boolean,
      default: false
    },
    isShowRequired: {
      type: Boolean,
      default: true
    },
    preLockFlag: {
      type: Boolean,
      default: null
    },
    isDisable: {
      type: Boolean,
      required: false,
      default: false
    },
    showCargoInfo: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  //  "sequence": 1,//1 客户名称，2  地址，7   国家，8  电话，9   邮箱，10  传真，15  企业代码，16   AEO代码
  data: function data() {
    return {
      isMaterials: false,
      isShowOpen: true,
      sequence: ['1', '2', '7', '8', '9', '10', '15', '16'],
      catalogContentIndex: 0 // 当前修改的数据是哪一条,
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.isMaterials = this.$route.path.indexOf("bookMaterialsDetail") !== -1;
    setTimeout(function () {
      // 订舱明细，POL 等于 THXXX 时，默认打开全部内容，不隐藏内容
      if (!_this.isShow && _this.formInfo.pol && _this.formInfo.pol.startsWith('TH')) {
        _this.isShow = true;
      }
      if (_this.formInfo.pol && _this.formInfo.pol.startsWith('MY')) {
        _this.isShow = true;
      }
      _this.isShowOpen = _this.isShow;
    }, 1000);
    // webBkCusCatalogComs=[{a:111,sequence:'',rowstatus:4},{a:22,sequence:'7',rowstatus:4}]
  },
  watch: {
    //尺寸，为空报错，自动赋0
    'form.cargoSize': {
      handler: function handler(newVal, oldVal) {
        if (newVal === '' || newVal === null || newVal === undefined) {
          this.$set(this.form, 'cargoSize', '0');
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])), {}, {
    form: {
      get: function get() {
        return this.formInfo;
      },
      set: function set(value) {
        this.$emit('update:form', value); // 触发父组件更新
      }
    }
  }),
  methods: {
    validateNull: _validate.validateNull,
    handleDoubleClick: function handleDoubleClick(item, index, biteLength) {
      //只有当可编辑情况下才能双击弹出框
      if (index === 1) {
        if (!this.isDisable && !this.preLockFlag) {
          this.$refs.myDialog.catalogContent = item;
          this.$refs.myDialog.openDialog(biteLength);
          this.catalogContentIndex = index;
        }
      } else {
        if (!this.isDisable && !(this.preLockFlag && this.form.pol && this.form.pol === 'CNDLC')) {
          this.$refs.myDialog.catalogContent = item;
          this.$refs.myDialog.openDialog(biteLength);
          this.catalogContentIndex = index;
        }
      }
    },
    confirm: function confirm(newContent) {
      if (this.catalogContentIndex === 1) {
        this.form.cargoDesc = newContent;
      } else if (this.catalogContentIndex === 2) {
        this.form.cargoShippingMark = newContent;
      }
    },
    //当：HS CODE(CN)  HS CODE(JP)  HS CODE(KR)   ,任意修改其一，另外两项同步变更,去掉同步。
    //   changeThree1(val) {
    //     this.form.hsCodeCn=this.form.hsCodeCn.replace(/[^\a-\z\A-\Z0-9\*\.]/g,'')
    //     this.form.hsCodeJp = this.form.hsCodeCn.replace(/[^\a-\z\A-\Z0-9\*\.]/g,'')
    //     this.form.hsCode = this.form.hsCodeCn.replace(/[^\a-\z\A-\Z0-9\*\.]/g,'')
    //   },
    //   changeThree2(val) {
    //     this.form.hsCodeJp=this.form.hsCodeJp.replace(/[^\a-\z\A-\Z0-9\*\.]/g,'')
    //     this.form.hsCodeCn = this.form.hsCodeJp.replace(/[^\a-\z\A-\Z0-9\*\.]/g,'')
    //     this.form.hsCode = this.form.hsCodeJp.replace(/[^\a-\z\A-\Z0-9\*\.]/g,'')
    //   },
    //   changeThree3(val) {
    //     this.form.hsCode=this.form.hsCode.replace(/[^\a-\z\A-\Z0-9\*\.]/g,'')
    //     this.form.hsCodeCn = this.form.hsCode.replace(/[^\a-\z\A-\Z0-9\*\.]/g,'')
    //     this.form.hsCodeJp = this.form.hsCode.replace(/[^\a-\z\A-\Z0-9\*\.]/g,'')
    //   },
    handleOpen: function handleOpen() {
      this.isShowOpen = !this.isShowOpen;
    },
    inputClass: function inputClass(fileName) {
      return {
        'different': this.isDifferent(fileName)
      };
    },
    isDifferent: function isDifferent(fileName) {
      return this.differentKeys.includes(fileName);
    },
    inputClassTwo: function inputClassTwo(fileName) {
      return {
        'different': this.isDifferentTwo(fileName)
      };
    },
    isDifferentTwo: function isDifferentTwo(fileName) {
      return this.bkCargoDiff.includes(fileName);
    },
    handleAddFileCargo: function handleAddFileCargo() {
      this.$refs.acceesoryCargo.dialogVisible = true;
    },
    changePackage: function changePackage(row, select) {
      this.form.cargoPackageDesc = select.packageName;
    },
    changeCom: function changeCom(row, select) {
      this.form.commodityName = select.commodityName;
    },
    showName: function showName(item) {
      var mapObject = {
        '1': this.$t('home.notifierName'),
        '2': this.$t('home.notifierAddress'),
        '7': this.$t('home.consignerCountry'),
        '8': this.$t('home.consignerPhone'),
        '9': this.$t('home.consignerEmail'),
        '10': this.$t('home.consignerFax'),
        '11': this.$t('home.connetName'),
        '12': this.$t('home.connetPhone'),
        '13': this.$t('home.connetEmail'),
        '14': this.$t('home.connetFax'),
        '15': this.$t('home.consignerEnterpriseCode'),
        '16': this.$t('home.consignerAEOCode')
      };
      return mapObject[item.sequence];
    },
    //同步箱信息的件重尺
    quantityToBoxInfo: function quantityToBoxInfo() {
      var _this$form$webBkConta;
      if (((_this$form$webBkConta = this.form.webBkContainerComs) === null || _this$form$webBkConta === void 0 ? void 0 : _this$form$webBkConta.length) === 1) {
        this.form.webBkContainerComs[0].quantity = this.form.cargoQuantity;
      }
    },
    weightToBoxInfo: function weightToBoxInfo() {
      var _this$form$webBkConta2;
      if (((_this$form$webBkConta2 = this.form.webBkContainerComs) === null || _this$form$webBkConta2 === void 0 ? void 0 : _this$form$webBkConta2.length) === 1) {
        this.form.webBkContainerComs[0].weight = this.form.cargoGrossWeight;
      }
    },
    sizeToBoxInfo: function sizeToBoxInfo() {
      var _this$form$webBkConta3;
      if (((_this$form$webBkConta3 = this.form.webBkContainerComs) === null || _this$form$webBkConta3 === void 0 ? void 0 : _this$form$webBkConta3.length) === 1) {
        this.form.webBkContainerComs[0].cntrSize = this.form.cargoSize;
      }
    }
  }
};